import { z } from 'zod';

const settingsSchema = z.object({
  allowedAttempts: z.number().default(1),
  flowType: z.enum(["no-feedback", "conditional", "training-in-order", "training-random", "test-in-order", "test-random"]).catch("training-in-order").default("training-in-order"),
  standalone: z.object({
    audience: z.enum(["young", "default"]).catch("default").default("default"),
    accentColor: z.string().nullish().default(null),
    speechSynthesis: z.object({
      primaryLanguage: z.enum(["Danish", "English", "German", "French", "Spanish"]).catch("Danish").default("Danish"),
      secondaryLanguage: z.enum(["Danish", "English", "German", "French", "Spanish"]).nullish().default(null)
    }).default({
      primaryLanguage: "Danish",
      secondaryLanguage: null
    })
  }).default({
    accentColor: null,
    audience: "default",
    speechSynthesis: {
      primaryLanguage: "Danish",
      secondaryLanguage: null
    }
  })
});

export { settingsSchema };
//# sourceMappingURL=schema.v2.settings.js.map
